// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__1F7gD","input":"Form_input__1jqBF","input--big":"Form_input--big__2XjTu","btn":"Form_btn__2_HPa"};